import apiHandler from "../core/apiHandler";

const productCategoryApi = apiHandler('product-categories');
export default productCategoryApi;